import { Link } from "react-router-dom";
import { MwlSymbol } from "@/components/MwlSymbol";

export function PublicShell({ children, member }) {
  return (
    <div className="min-h-screen" style={{ background: "var(--bg-primary)" }} data-testid="public-shell">
      <header className="max-w-5xl mx-auto px-6 py-5 grid grid-cols-[1fr_auto_1fr] items-center gap-4">
        <span />
        <MwlSymbol size={44} strokeWidth={5} testId="public-symbol" />
        <div className="flex justify-end">
          {member
            ? <Link to="/console/overview" data-testid="public-console-link" className="btn px-5 py-2 text-xs tracking-widest">← MEMBER CONSOLE</Link>
            : <Link to="/login" data-testid="public-login-link" className="btn px-5 py-2 text-xs tracking-widest">LOGIN / JOIN</Link>}
        </div>
      </header>
      <main className="max-w-5xl mx-auto px-6 py-12">{children}</main>
    </div>
  );
}
